import { GET_REF_BIKE_MODEL_REQUEST, GET_REF_BIKE_MODEL_REQUEST_SUCCESS, GET_REF_BIKE_MODEL_REQUEST_FAILURE } from '../constants/get_ref_bike_model.constants';

export const getRefBikeModelRequest = params => ({ type: GET_REF_BIKE_MODEL_REQUEST, params });
export const getRefBikeModelRequestSuccess = payload => ({ type: GET_REF_BIKE_MODEL_REQUEST_SUCCESS, payload });
export const getRefBikeModelRequestFailure = error => ({ type: GET_REF_BIKE_MODEL_REQUEST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/get_ref_bike_models.actions.js